import axios from "axios";
import React, { useEffect, useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { RedeemModal } from "./RedeemModal";
import { StopSIPModal } from "./StopSIPModal";
import Swal from "sweetalert2";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";
import { TfiReload } from "react-icons/tfi";
import { FaMinus, FaPlus } from "react-icons/fa";
import SipStartModal from "./modals/SipStartModal";
export const InvestmentTable = ({
  selectedCard,
  isChildrens,
  isFiltered,
  setStopSIP,
  effiBal,
  defSIP,
  fundType,
  setRedeemSuccess,
  setMapInternalHandle,
  investmentData,
  setInvestmentData,
  mapFund,
  unmapFund,
  isGoalLoaded,
  mapFundsBulk,
  isChecked,
  setIsChecked,
  shouldIncludeInvestment,
  getallFolio,
  isClientData,
  clientGoalMain,
  getDraftGoalData
}) => {
  const roomId = new URLSearchParams(useLocation().search).get("clientId");

  const [openFolio, setOpenFolio] = useState(null); // Level 1
  const [openFund, setOpenFund] = useState(null);   // Level 2


  const toggleFolio = (index) => {
    setOpenFolio(openFolio === index ? null : index);
    setOpenFund(null); // Close inner when switching
  };

  const toggleFund = (index) => {
    setOpenFund(openFund === index ? null : index);
  };
  // usefull
  // const goalNames = isClientData.dreamPoints.map(item => {
  //   const firstAction = item.action_data?.[0];

  //   // If goalText exists inside action_data → use it
  //   if (firstAction && firstAction.goalText) {
  //     return firstAction.goalText;
  //   }

  //   // else → use the root text
  //   return item.text;
  // });

  // console.log(goalNames);


  useEffect(() => {
    // console.log("✅ selectedCard updated:", selectedCard);

  }, [selectedCard]);

  const goalId = selectedCard?._id;
  const goalName = selectedCard?.text;
  const sub_id = selectedCard?.action_data[0]._id;

  // console.log("selectedCard-2", selectedCard);

  const handleToggle = () => {
    setIsChecked((prev) => !prev); // Toggle state
  };

  //  console.log("investmentData", investmentData, goalName);
  // useEffect(() => {
  //   getallFolio();
  // }, []);

  // const getallFolio = async () => {
  //   try {
  //     const response = await api.get(
  //       `advisor/allFolio/${roomId}`
  //     );

  //     if (response.data) {
  //       setInvestmentData(response.data);
  //       console.log("allFolio data show", response.data);
  //     }
  //   } catch (error) {
  //     console.log(error, "some Error");
  //   }
  // };

  async function getGoalEventDetail() {
    try {
      const response = await api.get(
        `advisor/get_open_goal_event/${roomId}`
      );

      const isEventInProgress = response.data;
      // console.log('fd',response.data);


      return response?.data;
    } catch (error) {
      console.error("getGoalEventDetail error:", error);
      return null;
    }
  }



  async function checkFolioInDraft(folioNumber, fundName, type) {
    const allData = {
      folioNumber,
      fundName,
      type: "",
      _id: roomId,
    };

    //  console.log("allData checkFolioInDraft:", allData);
    try {
      const response = await api.post(
        `advisor/check_event_folio`,
        allData
      );
      // console.log("responsecheckfolio:", response.data);
      return response?.data;
    } catch (error) {
      console.log("checkFolioInDraft error:", error);
    }
  }

  const [handleCallCount, setHandleCallCount] = useState(0);

  const isActionEnabled = (investment, selectedCard, goalId, goalName) => {

    // console.log('t3', investment,
    //   selectedCard,
    //   goalId,
    //   goalName);

    // console.log('t2', investment?.sub_id, selectedCard?.action_data?.[0]?._id, goalId, goalName);
    // console.log('goalNamexd', goalName, goalId, investment.goal_id)
    // If not mapped to any goal, allow mapping => enable button
    if (!investment.goal_name) return true;

    // If goal is 'Graduation' or 'Marriage', match sub_id
    if (
      goalId === "66d0280c9a75443e96fd3411" || // Marriage
      goalId === "66d028759a75443e96fd3412" // Graduation
    ) {
      console.log('t4', investment.sub_id, selectedCard?.action_data?.[0]?._id,)
      console.log('t4', investment.sub_name, selectedCard,)


      return investment.sub_id === selectedCard?.action_data?.[0]?._id;
    }

    // console.log('investment.goal_name', investment.goal_name, goalName, investment.sub_id, selectedCard)
    // For regular goals, match goal name
    console.log('t3', investment.goal_name.trim() === goalName.trim())
    return investment.goal_name.trim() === goalName.trim();
  };

  // const shouldIncludeInvestment = (
  //   investment,
  //   selectedCard,
  //   goalId,
  //   goalName
  // ) => {
  //   if (!investment.goal_name) return false;
  //   if (
  //     goalId === "66d0280c9a75443e96fd3411" ||
  //     goalId === "66d028759a75443e96fd3412"
  //   ) {
  //     console.log("goalId", goalId, investment.goal_name);
  //     return investment.sub_id === selectedCard?.action_data?.[0]?._id;
  //   }

  //   return investment.goal_name === goalName;
  // };

  // const canUnmapFolio = (investment, selectedCard, goalId, goalName) => {
  //   const isMapped =
  //     investment.goal_name ||
  //     ["66d0280c9a75443e96fd3411", "66d028759a75443e96fd3412"].includes(investment.goal_id);

  //   return isMapped && shouldIncludeInvestment(investment, selectedCard, goalId, goalName);
  // };

  const canUnmapFolio = (investment, selectedCard, goalId) => {
    if (!investment) return false;
    console.log('investment77', investment, goalId, investment.sub_id, selectedCard?.action_data?.[0]?._id)
    // 🧩 1. Check if folio is mapped to the same goal/sub-goal
    const isSameGoal =
      investment.goal_id === goalId &&
      (investment.sub_id &&
        investment.sub_id === selectedCard?.action_data?.[0]?._id);

    // ✅ 2. Only show Unmap if it's mapped to this goal/sub-goal
    return isSameGoal;
  };



  // const canMapFolio = (investment) => {

  //   console.log('investment.goal_name', investment.goal_name)
  //   const isMapped =
  //     investment.goal_name ||
  //     ["66d0280c9a75443e96fd3411", "66d028759a75443e96fd3412"].includes(investment.goal_id);

  //   console.log('isMapped', !isMapped)
  //   return !isMapped;
  // };


  const canMapFolio = (investment, selectedCard, goalId, goalName) => {
    if (!investment) return false;

    const childGoals = [
      "66d0280c9a75443e96fd3411", // Marriage
      "66d028759a75443e96fd3412", // Graduation
    ];

    // 🧩 1. Check if this folio is already mapped to the same goal/sub-goal
    const isSameGoal =
      investment.goal_id === goalId &&
      (investment.sub_id &&
        investment.sub_id === selectedCard?.action_data?.[0]?._id);

    console.log('isSameGoal', isSameGoal, selectedCard)
    // ✅ 2. If it's already mapped to this goal → hide Map
    if (isSameGoal) return false;

    // ✅ 3. If folio already has *some* goal (mapped anywhere else) → hide Map
    if (investment.goal_id || investment.sub_id) return false;

    // ✅ 4. Otherwise, unmapped → allow Map
    return true;
  };




  // Log the count in useEffect whenever it updates
  useEffect(() => {
    // console.log("Total times setMapInternalHandle called:", handleCallCount);
  }, [handleCallCount]);




  // mapFolio  fun
  const mapFolio = async (
    investment,
    client_id,
    savedAmount,
    runningSip = 0,
    folioNum,
    fundName
  ) => {
    // console.log("goalName", investment);

    try {
      // Check if a Goal Event is in progress
      const eventAllowed = await getGoalEventDetail();
      // console.log('fd',eventAllowed);


      // Optional: handle event status
      if (eventAllowed === 1) {
        Swal.fire({
          title: "Error",
          text: "Transaction already added to Goal Event",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
        return;
      }

      let savedAmount = investment.aum_as_per_rta;
      let runningSip = investment.sip;
      let folioNum = investment.folio_number;
      let fundName = investment.fund_name;
      const mpdat = { investment, savedAmount, runningSip, folioNum, fundName };
      // setMapInternalHandle(mpdat);

      mapFund({
        currentValue: investment.aum_as_per_rta,
        folioNumber: investment.folio_number,
        sipAmount: investment.sip,
        type: "map fn",
      });

      // console.log("mpdat", mpdat);

      // Check if the folio is currently part of a Goal Event
      const transAllowed = await checkFolioInDraft(
        folioNum,
        fundName,
        "someType",
        client_id
      );
      if (transAllowed === "1") {
        toast.error(
          "Cannot map or unmap folio while it is added to a Goal Event"
        );
        return;
      }

      // Calculate accumulated and running SIP amounts
      const accumulatedAmt =
        parseInt(isFiltered?.accumulatedAmount || 0) + parseInt(savedAmount);

      const runSIP =
        parseInt(isFiltered?.runningSIP || 0) + parseInt(runningSip);

      // Calculate future value for accumulated amount
      const currentTime = new Date();
      const yearsRemaining = isFiltered?.goalYear - currentTime.getFullYear();
      const accumFutureVal = Math.round(
        accumulatedAmt *
        Math.pow(1 + isFiltered?.expectedReturn / 100, yearsRemaining)
      );

      // Calculate future value for SIP contributions
      const totalMonths = yearsRemaining * 12;
      let monthEndValue = 0;
      let capitalGrowth = 0;

      if (runSIP !== 0) {
        for (let i = 1; i <= totalMonths; i++) {
          capitalGrowth =
            (monthEndValue + runSIP) * (isFiltered?.expectedReturn / 1200);
          monthEndValue += capitalGrowth + runSIP;
        }
        monthEndValue = Math.round(monthEndValue);
      }

      // Check if the projected amount exceeds the target threshold
      const projectedAmount = monthEndValue + accumFutureVal;
      if (projectedAmount > isFiltered?.staticTargetAmount * 1.5) {
        toast.error("Oops! Projected Amount cannot exceed Goal Target");
        return;
      }

      // console.log("projectedAmount", projectedAmount);

      // Prepare and send data to the server
      const childName =
        isChildrens?.find(
          (child) => child._id === selectedCard?.action_data?.[0]?.childId
        )?.name || "Unknown Child";


      // Get first word, trim, and capitalize first letter
      // const childNameFirst =
      // childName?.trim()?.split(" ")?.[0]?.charAt(0).toUpperCase() +
      // childName?.trim()?.split(" ")?.[0]?.slice(1);

      const edu =
        goalId === "66d028759a75443e96fd3412" && `${childName}'s Graduation`;
      const mari =
        goalId === "66d0280c9a75443e96fd3411" && `${childName}'s Marriage`;
      // console.log("mm-1", investment, childName, selectedCard);

      let payload = {
        uid: investment?.uid,
        member_id: investment?.pan_client_id,
        client_id: roomId,
        goal_name: goalName,
        sub_id: selectedCard?.action_data?.[0]?._id,
        sub_name: selectedCard?.action_data?.[0]?.goalText || goalName,
        goal_id: goalId,
      };


      // console.log("Payload for", childName, "=>", payload);

      const response = await api.post(
        `advisor/mapfolio`,
        payload
      );
      if (response?.data) {
        // console.log("Server response:", response.data);
        toast.success("Mapping successful!");

        getallFolio();

        if (response.data !== "") {
          // goalName = goalName.replace("&#8217;", "'");
          // console.log("mapFolio response.data", response.data);
          // conscept for dropdown
        }
      }
    } catch (error) {
      console.error("Error in mapFolio:", error);
      toast.error("An error occurred while mapping the folio.");
    }
  };

  // unmapFolio  fun
  const unmapFolio = async (
    investment,
    runningSip,
    savedAmount,
    folioNum,
    fundName,
    currentId
  ) => {
    try {
      let savedAmount = investment.aum_as_per_rta;
      let runningSip = investment.sip;
      let folioNum = investment.folio_number;
      let fundName = investment.fund_name;
      const mpdat = {
        investment,
        savedAmount,
        runningSip,
        folioNum,
        fundName,
      };
      // setMapInternalHandle(mpdat);

      unmapFund({
        currentValue: investment.aum_as_per_rta,
        folioNumber: investment.folio_number,
      });

      const eventAllowed = await getGoalEventDetail();
      // console.log('fd',eventAllowed);

      // Optional: handle event status
      if (eventAllowed === 1) {
        Swal.fire({
          title: "Error",
          text: "Transaction already added to Goal Event",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
        return;
      }

      const transAllowed = await checkFolioInDraft(folioNum, fundName);
      if (transAllowed === "1") {
        toast.error(
          "Cannot map or unmap folio while it is added to a Goal Event"
        );
        return;
      }

      const payload = {
        member_id: investment?.pan_client_id,
        // uid: uid?.replace('/', ''),
        uid: investment?.uid,
        goal_id: goalId,
      };

      const response = await api.post(
        `advisor/unmapFolio`,
        payload
      );

      if (response) {
        // console.log("unmapFolio Server response:", response.data);
        toast.success("Unmapping successful!");
        getallFolio();
        // conscept for dropdown
      }
    } catch (error) {
      console.error("Error in unmapFolio:", error);
      toast.error("An error occurred while unmapping the folio.");
    }
  };

  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [isCheckFolioResponse, setIsCheckFolioResponse] = useState({});
  const [selectedRedeemFund, setSelectedRedeemFund] = useState({});
  const [showstopSIPModal, setShowstopSIPModal] = useState(false);
  const [selectedstopSIPFund, setSelectedstopSIPFund] = useState({});
  
  const [showSipStartModal, setShowSipStartModal] = useState(false);
  const [selectedStartSIPFund, setSelectedStartSIPFund] = useState({});
  // redeem  fun
  const redeem = async (investment, fundName, folioNum, effiBal, fundType) => {
    const transactionType = "Redeem";
    console.log('redeeminvestment', investment);


    let actionClientId = Number(investment.client_id)
    let pan_client_id = Number(investment.pan_client_id) || Number(investment.client_id)

    // setShowRedeemModal(true);
    try {
      // Fetch open goal event status
      const response = await api.get(
        `advisor/get_open_goal_event/${actionClientId}`
      );
      // console.log("get_open_goal_event:", response.data);

      const isEventInProgress = response.data;


      if (isEventInProgress === 1) {
        Swal.fire({
          title: "Error",
          text: "Transaction already added to Goal Event",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn  ",
          },
        });
        return;
      }

      // Prepare payload for folio check
      const requestData = {
        folioNumber: investment?.folio_number || "",
        fundName: investment?.fund_name || "",
        type: "",
        _id: actionClientId,
      };

      try {
        // Check if folio exists in draft event
        const folioResponse = await api.post(
          `advisor/check_event_folio`,
          requestData
        );
        // console.log("response check_event_folio:", folioResponse.data);

        // if (folioResponse.data === 1) {
        //   Swal.fire({
        //     title: "Error",
        //     text: "Transaction already added to Goal Event",
        //     icon: "error",
        //     confirmButtonText: "OK",
        //     customClass: {
        //       confirmButton: "swal-confirm-btn  ",
        //     },
        //   });
        //   return false;
        // }

        // Check lock-in period restriction
        if (effiBal === 0 && fundType === "Equity - ELSS") {
          Swal.fire({
            title: "Redemption Failed!",
            text: "Fund is under lock-in period",
            icon: "error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn  ",
            },
          });
          return false;
        } else {
          const payload = {
            uid: investment?.uid,
            client_id: pan_client_id,
          };
          // API call to validate folio
          const response = await api.post(
            `advisor/checkFolio`,
            payload
          );

          const data = response?.data;
          if (data?.matchStatus == "success") {
            // console.log("Redeem Server Response:", response.data);
            setShowRedeemModal(true);
            setIsCheckFolioResponse(response.data);
            setSelectedRedeemFund(investment);
          } else {
            Swal.fire({
              title: "Redemption Failed!",
              text: data?.message,
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn  ",
              },
            });
          }
        }

        // console.log("Proceeding with transaction...");
      } catch (folioError) {
        console.error("Error in check_event_folio:", folioError);
        Swal.fire({
          title: "Error",
          text: "Failed to check folio details. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn  ",
          },
        });
      }

      // return response?.data;
    } catch (error) {
      console.error("Error in getGoalEventDetail:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch goal event details. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn  ",
        },
      });
    }
  };

  // stopSIP  fun
  const stopSIP = async (
    investment
    // sip,
    // fid,
    // uid,
    // fundName,
    // folioNum,
    // currentVal,
    // clientId,
    // minRedemptionAmt,
    // scheme_code,
    // goal_name
  ) => {
    console.log("investment stopSIP", investment);
    var type = "Stop_sip";
    let sip = investment?.sip;
    let fid = investment?.fid;
    let uid = investment?.uid;
    let fundName = investment?.fund_name;
    let folioNum = investment?.folio_number;
    let currentVal = investment?.currentVal || investment?.aum_as_per_rta;
    let clientId = Number(investment?.client_id);
    let minRedemptionAmt = investment?.minRedemptionAmt;
    let scheme_code = investment?.scheme_code;
    let goal_name = investment?.goal_name;
    let pan_client_id = Number(investment.pan_client_id)
    console.log(
      "Stop_SIP",
      investment,
      sip,
      fid,
      uid,
      fundName,
      folioNum,
      currentVal,
      clientId,
      minRedemptionAmt,
      scheme_code,
      goal_name
    );

    try {
      console.log("wokring...")
      const eventAllowed = await getGoalEventDetail();
      console.log('fd', eventAllowed);

      // Optional: handle event status
      if (eventAllowed === 1) {
        Swal.fire({
          title: "Error",
          text: "Transaction already added to Goal Event",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
        return;
      }
      const transAllowed = await checkFolioInDraft(folioNum, fundName, type);
      // console.log('fd transAllowed', transAllowed);

      if (transAllowed === "1") {
        toast.error("Transaction already added to Goal Event");
        return false;
      }
      // $('#redeemModal').css('display','none');
      // $('#stopSIPModal').css('display','none');
      // $('#investModal').css('display','none');`

      const payload = {
        fid: fid,
        uid: uid,
        // uid: uid?.replace('/', ''),
        client_id: pan_client_id,
      };

      // console.log("payload", payload);
      const response = await api.post(
        `advisor/checkFolio`,
        payload
      );


      if (response?.data) {
        // console.log("Stop_sip response:", response.data);
        // toast.success("redeem successful!");
        setShowstopSIPModal(true);
        setIsCheckFolioResponse(response?.data);
        setSelectedstopSIPFund(investment);

        // conscept for dropdown
        if (response?.data !== "") {
          // toast.success("redeem ");
        }
      }
    } catch (error) { }
  };


  const startSIP = async (investment) => {
    console.log("Start_SIP", investment);
    setShowSipStartModal(true);
    setSelectedStartSIPFund(investment);
  }

  const grandTotal = Object.values(investmentData || {}).reduce(
    (acc, investor) => {
      const equityTotal = (investor?.Equity || []).reduce(
        (sum, fund) => sum + (parseFloat(isChecked ? fund?.effiBal : fund?.aum_as_per_rta) || 0),
        0
      );
      const sifTotal = (investor?.SIF || []).reduce(
        (sum, fund) => sum + (parseFloat(isChecked ? fund?.effiBal : fund?.aum_as_per_rta) || 0),
        0
      );

      const hybridTotal = (investor?.Hybrid || []).reduce(
        (sum, fund) => sum + (parseFloat(isChecked ? fund?.effiBal : fund?.aum_as_per_rta) || 0),
        0
      );
      const otherTotal = (investor?.Other || []).reduce(
        (sum, fund) => sum + (parseFloat(isChecked ? fund?.effiBal : fund?.aum_as_per_rta) || 0),
        0
      );

      const debtTotal = (investor?.Debt || []).reduce(
        (sum, fund) => sum + (parseFloat(isChecked ? fund?.effiBal : fund?.aum_as_per_rta) || 0),
        0
      );

      return acc + equityTotal + debtTotal + hybridTotal + otherTotal + sifTotal;
    },
    0
  );

  // Format to Indian Rupees with commas and 2 decimal places
  const formattedTotal = grandTotal.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 0, });

  // console.log("inveesssss", investmentData, selectedCard?.text);

  return (
    <div className="row">
      <StopSIPModal
        show={showstopSIPModal}
        onHide={() => setShowstopSIPModal(false)}
        isCheckFolioResponse={isCheckFolioResponse}
        setStopSIP={setStopSIP}
        selectedstopSIPFund={selectedstopSIPFund}
        isFiltered={isFiltered}
        roomId={roomId}
      />
      <RedeemModal
        show={showRedeemModal}
        onHide={() => setShowRedeemModal(false)}
        isCheckFolioResponse={isCheckFolioResponse}
        selectedRedeemFund={selectedRedeemFund}
        isFiltered={isFiltered}
        roomId={roomId}
        setRedeemSuccess={setRedeemSuccess}

        selectedCard={selectedCard}
      />
      <SipStartModal
        defSIP={defSIP}
        show={showSipStartModal}
        onHide={() => setShowSipStartModal(false)}
        selectedStartSIPFund={selectedStartSIPFund}
        isFiltered={isFiltered}
        roomId={roomId}
        clientGoalMain={clientGoalMain}
        getDraftGoalData={getDraftGoalData}
      />
      <Toaster position="top-center" reverseOrder={false} />
      <div className="col">
        <div className="scroll-container d-md-block d-none">
          {
            Object.keys(investmentData).length !== 0 &&
            <table className="table ">
              <thead className="sticky-header">
                <tr className="green-bg ">
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    Folio #
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    Fund Name
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers d-flex gap-2 sticky-header back-clrgreen"
                  >
                    {isChecked ? "Load Free Unit" : "Current Value"}
                    <span className="form-check form-switch toggle-color">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={isChecked}
                        onChange={handleToggle}
                      />
                    </span>
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    XIRR
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    Abs Rtn
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    Active SIP
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    Mapped To
                  </th>
                  <th
                    scope="col"
                    className="txt-color-revers sticky-header back-clrgreen"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(investmentData).map(
                  ([category, goals], index) => (
                    <React.Fragment key={index}>
                      <tr className="border-bottom">
                        <td
                          colSpan="8"
                          className="fw-bold"
                          style={{ backgroundColor: "#F6FBF9" }}
                        >
                          <p className="fs-14 my-3">{category}</p>
                        </td>
                      </tr>

                      {Object.entries(goals).map(([goal, investments]) => (
                        <React.Fragment key={goal}>
                          <tr className="border-bottom" >
                            <td colSpan="8" className="fw-semibold" style={{ backgroundColor: "#d0ebd0" }}>
                              <p className="fs-14 my-3">{goal}</p>
                            </td>
                          </tr>

                          {investments.map((investment, i) => (
                            <tr key={i} className="border-bottom">
                              <td className="align-middle">{investment.folio_number}</td>
                              <td className="align-middle">{investment.fund_name}</td>
                              <td className="align-middle">
                                {formatRupees(isChecked ? investment?.effiBal : investment?.aum_as_per_rta)}
                              </td>
                              <td className="align-middle">{investment.cagr || ""}</td>
                              <td className="align-middle">{investment.absRtr || ""}</td>
                              <td className="align-middle">{investment.sip}</td>
                              <td className="align-middle">
                                <p className="fs-14 fw-normal my-3">
                                  {["66d0280c9a75443e96fd3411", "66d028759a75443e96fd3412"].includes(investment.goal_id)
                                    ? investment.sub_name || "—"
                                    : investment.goal_name || "—"}

                                </p>
                              </td>


                              <td className="align-middle">
                                <div className="d-flex gap-4 align-items-center">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      style={{
                                        backgroundColor: "#198754",
                                        borderColor: "#198754",
                                      }}
                                      disabled={
                                        !isActionEnabled(
                                          investment,
                                          selectedCard,
                                          goalId,
                                          goalName
                                        )
                                      }
                                    >
                                      Action
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      {/* {investment.goal_name === "" && (
                                    <Dropdown.Item
                                      onClick={() => mapFolio(investment)}
                                    >
                                      Map
                                    </Dropdown.Item>
                                  )}
                                  {investment.goal_name === goalName && (
                                    <Dropdown.Item
                                      onClick={() => unmapFolio(investment)}
                                    >
                                      Unmap
                                    </Dropdown.Item>
                                  )} */}

                                      {canMapFolio(investment,
                                        selectedCard,
                                        goalId,
                                        goalName) && (
                                          <Dropdown.Item
                                            className="custom-dropdown-item"

                                            onClick={() => mapFolio(investment)}
                                          >
                                            Map
                                          </Dropdown.Item>
                                        )}
                                      {/* {console.log('Stop_SIP',investment)} */}

                                      {canUnmapFolio(
                                        investment,
                                        selectedCard,
                                        goalId,
                                        goalName
                                      ) && (
                                          <Dropdown.Item
                                            className="custom-dropdown-item"
                                            onClick={() => unmapFolio(investment)}
                                          >
                                            Unmap
                                          </Dropdown.Item>
                                        )}
                                      {investment.aum_as_per_rta > 0 && (
                                        <Dropdown.Item
                                          className="custom-dropdown-item"
                                          onClick={() => redeem(investment)}
                                        >
                                          Redeem
                                        </Dropdown.Item>
                                      )}

                                      {investment.sip > 0 && (
                                        <Dropdown.Item
                                          className="custom-dropdown-item"
                                          onClick={() => stopSIP(investment)}
                                        >
                                          Stop SIP
                                        </Dropdown.Item>
                                      )}
                                       <Dropdown.Item
                                          className="custom-dropdown-item"
                                          onClick={() => startSIP(investment)}
                                        >
                                          Start SIP
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>

                                  <div onClick={() => unmapFolio(investment)} >
                                    <TfiReload color="red" size={10} />
                                  </div>
                                </div>
                                {/*                           
                          <Dropdown>
                                <Dropdown.Toggle
                                  style={{
                                    backgroundColor: "#198754",
                                    borderColor: "#198754",
                                  }}
                                >
                                  Action
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {investment.goal_name === "" && (
                                    <Dropdown.Item
                                      onClick={() => mapFolio(investment)}
                                    >
                                      Map
                                    </Dropdown.Item>
                                  )}
                                  {investment.goal_name === goalName && (
                                    <Dropdown.Item
                                      onClick={() => unmapFolio(investment)}
                                    >
                                      Unmap
                                    </Dropdown.Item>
                                  )}
                                  {investment.aum_as_per_rta > 0 && (
                                    <Dropdown.Item
                                      onClick={() => redeem(investment)}
                                    >
                                      Redeem
                                    </Dropdown.Item>
                                  )}
                                  {investment.sip > 0 && (
                                    <Dropdown.Item
                                      onClick={() => stopSIP(investment)}
                                    >
                                      Stop SIP
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown> */}
                              </td>
                            </tr>
                          ))}

                          <tr>
                            <td style={{ backgroundColor: "#F6FBF9" }}></td>
                            <td style={{ backgroundColor: "#F6FBF9" }}>Total</td>
                            <td style={{ backgroundColor: "#F6FBF9" }}>
                              {/* {console.log("investmentData", investments)} */}
                              {Number(
                                investments?.reduce((total, investment) => {
                                  const amount = isChecked
                                    ? parseFloat(investment.effiBal || 0)
                                    : parseFloat(investment.aum_as_per_rta || 0);

                                  return total + (isNaN(amount) ? 0 : amount);
                                }, 0)
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </td>

                            <td
                              colSpan="5"
                              style={{ backgroundColor: "#F6FBF9" }}
                            ></td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  )
                )}

                <tr className="">
                  <td
                    colSpan="8"
                    className="text-center"
                    style={{ backgroundColor: "rgba(82, 181, 140, 0.16)" }}
                  >
                    <p className="fs-14 fw-bold my-3">
                      Grand Total: <span>{formattedTotal}</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          }

        </div>
        {/* ---------------- MOBILE VIEW ---------------- */}
        <div className="scroll-container d-md-none d-block my-3 px-2 ">

          {Object.entries(investmentData).map(([category, goals], cIndex) => (
            <div key={cIndex} className="mb-3">

              {/* ---------------- LEVEL 1 : CATEGORY ---------------- */}
              <div
                className="card p-3 d-flex flex-row justify-content-between align-items-center back-clrgreen txt-color-revers"
                style={{ background: "#f9f9f9" }}
                onClick={() => toggleFolio(cIndex)}
              >
                <span className="fw-bold">{category}</span>

                {openFolio === cIndex ? (
                  <FaMinus className="refer" />
                ) : (
                  <FaPlus className="refer" />
                )}
              </div>

              {/* ---------------- SHOW GOALS ---------------- */}
              {openFolio === cIndex && (
                <div className="mt-2">

                  {Object.entries(goals).map(([goalName, investments], gIndex) => (
                    <div key={gIndex} className="mb-2">

                      {/* ---------------- LEVEL 2 : GOAL ---------------- */}
                      <div
                        className="card p-3 d-flex flex-row justify-content-between align-items-center"
                        onClick={() => toggleFund(`${cIndex}-${gIndex}`)}
                      >
                        <span className="fw-semibold">{goalName}</span>

                        {openFund === `${cIndex}-${gIndex}` ? (
                          <FaMinus className="txt-color" />
                        ) : (
                            <FaPlus className="txt-color" />
                        )}
                      </div>

                      {/* ---------------- LEVEL 3 : FUND DETAILS ---------------- */}
                      {openFund === `${cIndex}-${gIndex}` && (
                        <div className="mt-2">

                          {investments.map((investment, iIndex) => (
                            <div key={iIndex} className="card p-3 mb-3 shadow-sm">

                              {[
                                { key: "Folio", value: investment.folio_number },
                                { key: "Fund Name", value: investment.fund_name },
                                {
                                  key: isChecked ? "Load Free Unit" : "Current Value",
                                  value: Number(
                                    isChecked ? investment.effiBal : investment.aum_as_per_rta
                                  ).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                },
                                { key: "XIRR", value: investment.cagr },
                                { key: "Abs Return", value: investment.absRtr },
                                { key: "Active SIP", value: investment.sip },
                                {
                                  key: "Mapped To",
                                  value:
                                    investment.goal_id === "66d028759a75443e96fd3412" ||
                                      investment.goal_id === "66d0280c9a75443e96fd3411"
                                      ? investment.sub_name
                                      : investment.goal_name,
                                },
                              ].map((item, k) => (
                                <div
                                  key={k}
                                  className="d-flex justify-content-between py-2 border-bottom"
                                >
                                  <span
                                    className="fw-bold text-dark"
                                    style={{ minWidth: "130px" }}
                                  >
                                    {item.key}
                                  </span>
                                  <span className="fw-semibold text-dark text-end">
                                    {item.value}
                                  </span>
                                </div>
                              ))}

                            </div>
                          ))}
                          {/* FUND TOTAL (Goal-Wise Total) */}
                          <div className="card p-3 mb-2" style={{ backgroundColor: "#F6FBF9" }}>
                            <div className="d-flex justify-content-between">
                              <span className="fw-bold text-success">Fund Total</span>

                              <span className="fw-bold text-success">
                                {Number(
                                  investments.reduce((acc, inv) => {
                                    const amount = isChecked
                                      ? parseFloat(inv?.effiBal || 0)
                                      : parseFloat(inv?.aum_as_per_rta || 0);
                                    return acc + (isNaN(amount) ? 0 : amount);
                                  }, 0)
                                ).toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </div>
                          </div>

                        </div>
                      )}

                    </div>
                  ))}

                </div>
              )}

            </div>
          ))}
          {/* GRAND TOTAL MOBILE */}
          <div className="card p-3 my-3 shadow-sm" style={{ backgroundColor: "#F6FBF9" }}>
            <div className="d-flex justify-content-between">
              <span className="fw-bold text-success">Grand Total</span>

              <span className="fw-bold text-success">
                {formattedTotal}
              </span>
            </div>
          </div>
        </div>

      </div>
    </div >
  );
};  